import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'

import { ResultCode } from '../../../domain/authentication.model'
import { AuthService } from '../../../services/auth.service'
import { NotificationService } from '../../../services/notification.service'

@Component({
  selector: 'bmcore-confirm-email-page',
  templateUrl: './bmcore-confirm-email-page.component.html',
  styleUrls: ['./bmcore-confirm-email-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreConfirmEmailPageComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    const code = this.activatedRoute.snapshot.queryParams['code']
    this.confirmEmail(code)
  }

  confirmEmail(code: string) {
    this.authService.confirmNewEmail(code).subscribe(
      res => {
        if (res.resultCode === ResultCode.Success) {
          this.authService.me()
        } else {
          this.notificationService.handleError(res.messages[0])
        }
      },
      err => this.notificationService.handleError(err.message),
      () => this.router.navigate([''])
    )
  }
}
